import cookies from 'js-cookie';
export var backdoorCountryCode = 'UA'; // Ukraine country code
export var backdoorCookie = 'forceDCF'; // Cookie that need to be used to force DCF
export var byCountryFactory = function (_a) {
    var supportedCountries = _a.supportedCountries;
    return function (_a) {
        var countryCode = _a.countryCode;
        /** in this condition we are allowing to show DCF for the Ukraine country code
         * if specific cookie "forceDCF" exists
         */
        // tslint:disable-next-line:no-backbone-get-set-outside-model
        if (cookies.get(backdoorCookie) === 'TRUE' && countryCode === backdoorCountryCode) {
            return true;
        }
        else {
            return supportedCountries.includes(countryCode);
        }
    };
};
//# sourceMappingURL=byCountry.js.map